/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('RelayPoints.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content class="mc-carpool-relaypoints" color="primary" forceOverscroll="false">
      <div
        class="ion-text-center ion-margin-top"
        v-if="this.$store.getters.statusGetEvent == 'loading'"
      >
        <ion-icon size="large" color="light" class="rotating" name="sync"></ion-icon>
      </div>

      <div class="mc-white-container">
        <RelaypointsMap :filter="'covoit'" :select="true" />
        <br><br>
        <SearchQuick :from="'relaypoint'" />
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.mc-carpool-relaypoints {


}
</style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";
import { address } from "../../Shared/Mixin/address.mixin";
import SearchQuick from "../Shared/Components/SearchQuick.component";
import MiniMap from "../Shared/Components/MiniMap.component";
import RelaypointsMap from "../Shared/Components/RelaypointsMap.component";

export default {
  name: "carpool-relaypoints",
  mixins: [toast, address],
  components: { SearchQuick, MiniMap, RelaypointsMap },
  data() {
    return {
      LMarker: [],
    };
  },
  created() {

  },
  mounted() {

  },
  computed: {
  },
  methods: {

  }
};
</script>
